export const accordion = async (target) => {
  const menu = document.querySelectorAll(`${target}`);
  menu.forEach(accordionMenu => {
    accordionMenu.addEventListener('click', function(e) {
      if(e.target.classList.contains('legal-submenu-item')) {
        e.stopImmediatePropagation();

      } else {
        this.classList.toggle('active');

        const hiddenElement = this.querySelector('.faq-answer') || this.closest('.checklist-main-container, .legal-menu-item, .pricing-plan-card').querySelector('.content-check-list, .legal-submenu, .card-detail');
        hiddenElement.classList.toggle('active');

        hiddenElement.style.maxHeight
          ? hiddenElement.style.maxHeight = null
          : hiddenElement.style.maxHeight = 'fit-content';
      }

    });
  });
}

export const showMoreFaqs = async () => {
  const faqButton = document.querySelector('[data-toggle="show-more"]');
  const questionButtons = document.querySelectorAll('.faqs-cards.hidden') || document.querySelectorAll('.faqs-cards.hidden.visible');

  faqButton && faqButton.addEventListener('pointerdown', () => {
    questionButtons.forEach(question => {
      const answer = question.querySelector('.faq-answer');
      question.style.maxHeight
        ? question.style.maxHeight = null
        : question.style.maxHeight = question.style.maxHeight = (question.scrollHeight + answer.scrollHeight + 32 ) + 'px';;

      question.classList.toggle('visible');
      question.classList.contains('visible')
        ? faqButton.querySelector('.texts').textContent = faqButton.dataset.textHide
        : faqButton.querySelector('.texts').textContent = faqButton.dataset.textShow;

    })
  });
};

